// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__T-Ge0","inputDescription":"styles_inputDescription__2JdLT"};